"use client";

import { useTradeType } from "#/hooks/useTradeType";
import { useTradePanelTab } from "#/store/app/tradePanel/tradePanelTab";
import { useIsOptionHedged } from "#/store/options/tradePanel/isOptionHedged";

import { HedgeTradeButton } from "./components/HedgeTradeButton/HedgeTradeButton";
import { LimitTradeButton } from "./components/LimitTradeButton/LimitTradeButton";
import { MarketTradeButton } from "./components/MarketTradeButton/MarketTradeButton";
import { RFQTradeButton } from "./components/RFQTradeButton/RFQTradeButton";

export const TradeButton: React.FC = () => {
  const { isMarket, isLimit, isRFQ } = useTradeType();
  const { isOptions } = useTradePanelTab();
  const { isOptionHedged } = useIsOptionHedged();

  const showHedgeTradeButton = isOptions && isOptionHedged;

  return (
    <>
      {isMarket &&
        (showHedgeTradeButton ? <HedgeTradeButton /> : <MarketTradeButton />)}
      {isLimit && <LimitTradeButton />}
      {isRFQ && <RFQTradeButton />}
    </>
  );
};
